import { render } from "./BlogPage.vue?vue&type=template&id=24217b53&scoped=true"
import script from "./BlogPage.vue?vue&type=script&lang=js"
export * from "./BlogPage.vue?vue&type=script&lang=js"

import "./BlogPage.vue?vue&type=style&index=0&id=24217b53&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24217b53"]])

export default __exports__